export default {
  paymentList: [],
  restrictedDeposit: [],
  isShowFirstPromotionPopup: true,
}
